import { loadCSS } from '../../utils';
let view = null;

export default {
	namespace: 'template-projects',
	beforeEnter: async ({ current, next, trigger }) => {
		await loadCSS(WPDATA.themeUrl + '/dist/css/t-projects.css');

		const { default: TemplateProjects } = await import(
			/* webpackChunkName: "template-projects" */ '../../templates/TemplateProjects'
		);
		view = new TemplateProjects(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
